<mat-toolbar class="toolbar">
  <!--  *************************** -->
  <!--        HAMBURGER BUTTON      -->
  <!--  *************************** -->
  <button
    type="button"
    mat-icon-button
    (click)="drawer.toggle()"
    *ngIf="graphicUtils.isScreenWidthGreater(gmService.SMALL_SCREEN_THRESHOLD)">
    <mat-icon>menu</mat-icon>
  </button>

  <span class="component-title" *ngIf="!!gmService.menuVoice">
    {{'MENU.' + gmService.menuVoice.id | translate}}
  </span>

  <span class="example-spacer"></span>

  <!--  *************************** -->
  <!--          APP VERSION         -->
  <!--  *************************** -->
  <span class="envText" fxHide fxShow.gt-sm>Ver. {{getAppVersion()}}</span>

  <!--  *************************** -->
  <!--          ENVIRONMENTS        -->
  <!--  *************************** -->
  <span class="envText" *ngIf="env !== 'prod'" fxHide fxShow.gt-sm>{{printEnvironments()}}</span>

  <!--  &lt;!&ndash;  *************************** &ndash;&gt;-->
  <!--  &lt;!&ndash;      LANGUAGE SELECTION      &ndash;&gt;-->
  <!--  &lt;!&ndash;  *************************** &ndash;&gt;-->
  <!--  <button mat-icon-button [matMenuTriggerFor]="langMenu" fxShow>-->
  <!--    <mat-icon>language</mat-icon>-->
  <!--  </button>-->
  <mat-menu #langMenu="matMenu" fxShow>
    <div *ngFor="let locale of languages" mat-menu-item (click)="changeLanguage(locale.locale)" class="flag-icon-style">
      <span class="fi fi-{{locale.countryFlag}}"></span>
      <span class="textFont smallFont">{{'  '+locale.locale}}</span>
    </div>
  </mat-menu>


  <button mat-icon-button title="Esporta excel dispositivi" (click)="exportAllCustomerDeviced()" fxHide fxShow.gt-sm>
    <mat-icon>analytics</mat-icon>
  </button>

  <button mat-icon-button title="Apri mappa" (click)="openDeviceMap()" fxHide fxShow.gt-sm>
    <mat-icon>map</mat-icon>
  </button>

  <button mat-icon-button title="ThingsBoard LogIn" (click)="tbLogin()" fxHide fxShow.gt-sm>
    <img src="assets/thingsboard_blue.png" height="24px"/>
  </button>


  <!--  *************************** -->
  <!--             ACCOUNT          -->
  <!--  *************************** -->
  <span class="user-chip"  fxHide fxShow.gt-md
        [matTooltip]="'User menu'"
        [matTooltipClass]="'multiline-tooltip'"
        [matTooltipPosition]="'below'">
    <button mat-menu-item class="customMatMenuItem noPadding" (click)="openChangePassword()">

      <mat-icon class="customIcon">account_circle</mat-icon>
      {{gmService.user.firstname}} {{gmService.user.lastname}}
  </button>
  </span>
  <button mat-icon-button title="{{gmService.user.firstname}} {{gmService.user.lastname}}" (click)="openChangePassword()" fxHide fxShow.md>
    <mat-icon>account_circle</mat-icon>
  </button>

  <!--  *************************** -->
  <!--             LOGOUT           -->
  <!--  *************************** -->
  <button mat-icon-button (click)="logout()" fxHide fxShow.gt-sm>
    <mat-icon>logout</mat-icon>
  </button>

  <!--  *************************  -->
  <!--        DROPDOWN MENU        -->
  <!--  *************************  -->
  <button mat-icon-button [matMenuTriggerFor]="dropMenu" fxHide fxShow.lt-md>
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #dropMenu="matMenu" fxHide fxShow.lt-md>
    <p mat-menu-item *ngIf="env !== 'prod'" [disableRipple]="true" class="menuItemElement">{{printEnvironments()}}</p>
    <button mat-menu-item title="{{gmService.user.firstname}} {{gmService.user.lastname}} menu" (click)="openChangePassword()">
      <mat-icon>account_circle</mat-icon>{{gmService.user.firstname}} {{gmService.user.lastname}}
    </button>
    <button mat-menu-item aria-label="Logout" (click)="logout()">
      <mat-icon>logout</mat-icon>Logout
    </button>
  </mat-menu>


</mat-toolbar>
